<div class="item-list-container">
  @if (loading) {
  <div class="loading-message">
    <fa-icon [icon]="faSpinner" animation="spin"></fa-icon>
    <span>{{ 'MESSAGE.LOADING' | translate }}</span>
  </div>
  }

  @if (!loading) {
  <div class="items-list">
    @for (item of items; track trackByItem(i, item); let i = $index) {
    <div class="item-card" (click)="onItemClick(item)">
      <div class="item-content">
        @if (config.showCheckboxes) {
        <div class="item-checkbox">
          <input type="checkbox" [checked]="isItemSelected(item)" (change)="onCheckboxChange(item, $event)"
            (click)="$event.stopPropagation()" />
        </div>
        }
        @if (config.showSelectCheckboxes) {
        <div class="item-select-checkbox" (click)="$event.stopPropagation()">
          @if (isSelectCheckboxVisible(item)) {
          <input type="checkbox" [checked]="isItemSelected(item)" [disabled]="isSelectCheckboxDisabled(item)"
            (change)="onCheckboxChange(item, $event)" />
          } @else {
          <span class="select-checkbox-placeholder"></span>
          }
        </div>
        }
        @if (!config.showCheckboxes && !config.showSelectCheckboxes) {
        <fa-icon [icon]="config.itemIcon" [class]="config.itemIconClass || 'item-icon'">
        </fa-icon>
        }
        <div class="item-info">
          <div class="item-name-row">
            <div class="item-name">
              {{ item.name }}
              @if (showSubname && item['subname']) {
              <span class="item-subname">
                ({{ item['subname'] }})
              </span>
              }
              @if (item['customIcon']) {
              <fa-icon [icon]="item['customIcon']" class="custom-item-icon"
                [title]="item['customIconTitle'] | translate">
              </fa-icon>
              }
            </div>

            @if (item.tags && item.tags.length) {
            <div class="item-tag">
              @for (t of item.tags; track t.id) {
              <span class="tag-single clickable" [style.background-color]="t.bg_color" [style.color]="t.text_color"
                [title]="t.name" (click)="onTagClick(t, $event)">
                {{ t.name }}
              </span>
              }
            </div>
            } @else if (item.tag) {
            <div class="item-tag">
              <span class="tag-single clickable" [style.background-color]="item.tag.bg_color"
                [style.color]="item.tag.text_color" [title]="item.tag.name" (click)="onTagClick(item.tag, $event)">
                {{ item.tag.name }}
              </span>
            </div>
            }
          </div>

          @if (config.showType && config.typePosition === 'inline' && item.type) {
          <div class="item-type-inline">
            <span class="type-badge" [class]="'type-' + item.type">{{ getTypeLabel(item.type) | translate }}</span>
          </div>
          }

          @if (config.showConfigSummary && item['configSummary']) {
          <div class="item-config-section" (click)="$event.stopPropagation()">
            <button class="config-toggle-btn" (click)="toggleConfigSummary(item, $event)">
              <fa-icon [icon]="faCog"></fa-icon>
              <span>{{ 'RESULT.EXECUTION_CONFIG' | translate }}</span>
              <fa-icon [icon]="isConfigExpanded(item) ? faChevronUp : faChevronDown" class="config-chevron"></fa-icon>
            </button>
            <div class="config-panel" [class.expanded]="isConfigExpanded(item)">
              <div class="config-panel-inner">
                <div class="config-grid">
                  @if (item['configSummary'].model_name) {
                  <div class="config-row config-row--full">
                    <span class="config-label">{{ 'RESULT.MODEL_NAME' | translate }}</span>
                    <span class="config-value">{{ item['configSummary'].model_name }}</span>
                  </div>
                  }
                  @if (item['configSummary'].delfos_server) {
                  <div class="config-row">
                    <span class="config-label">{{ 'SETTINGS.PREFERENCES.DELFOS_SERVER' | translate }}</span>
                    <span class="config-value">{{ item['configSummary'].delfos_server }}</span>
                  </div>
                  }
                  @if (item['configSummary'].delfos_llm) {
                  <div class="config-row">
                    <span class="config-label">{{ 'SETTINGS.PREFERENCES.DELFOS_LLM' | translate }}</span>
                    <span class="config-value">{{ item['configSummary'].delfos_llm }}</span>
                  </div>
                  }
                  @if (!item['configSummary'].use_multimodal && item['configSummary'].di2winocr_server) {
                  <div class="config-row">
                    <span class="config-label">{{ 'SETTINGS.PREFERENCES.OCR_SERVER' | translate }}</span>
                    <span class="config-value">{{ item['configSummary'].di2winocr_server }}</span>
                  </div>
                  }
                  @if (!item['configSummary'].use_multimodal && item['configSummary'].di2winocr_features) {
                  <div class="config-row">
                    <span class="config-label">{{ 'SETTINGS.PREFERENCES.OCR_FEATURES' | translate }}</span>
                    <span class="config-value config-value--with-badge">
                      <span class="config-value-text">{{ item['configSummary'].di2winocr_features }}</span>
                      @if (item['configSummary'].di2winocr_features_customized) {
                      <span class="config-custom-badge">{{ 'OCR_OVERRIDE.BADGE' | translate }}</span>
                      }
                    </span>
                  </div>
                  }
                  <div class="config-row">
                    <span class="config-label">{{ 'EXECUTE_MODAL.CLEAR_RESPONSE_CACHE' | translate }}</span>
                    <span class="config-value">{{ (item['configSummary'].clear_delfos_cache ? 'COMMON.YES' : 'COMMON.NO') | translate }}</span>
                  </div>
                  @if (!item['configSummary'].use_multimodal) {
                  <div class="config-row">
                    <span class="config-label">{{ 'EXECUTE_MODAL.CLEAR_OCR_CACHE' | translate }}</span>
                    <span class="config-value">{{ (item['configSummary'].clear_di2winocr_cache ? 'COMMON.YES' : 'COMMON.NO') | translate }}</span>
                  </div>
                  }
                </div>
              </div>
            </div>
          </div>
          }
        </div>
      </div>
      @if (config.showMetadata) {
      <div class="item-metadata">
        @if (config.showType && config.typePosition !== 'inline' && item.type) {
        <span class="type-badge" [class]="'type-' + item.type">
          @if (item.type === 'PENDING') {
          <fa-icon [icon]="faSpinner" animation="spin" class="status-spinner"></fa-icon>
          @if (item.progress) {
          {{ item.progress.percentage }}% {{ 'INTERACTIONS.RESULTS.STATUS.COMPLETED' | translate }}
          } @else {
          {{ getTypeLabel(item.type) | translate }}
          }
          } @else {
          {{ getTypeLabel(item.type) | translate }}
          }
        </span>
        }
        @if (item.created_date) {
        <span class="date-info">
          <fa-icon [icon]="faCalendar" class="metadata-icon"></fa-icon>
          {{ item.created_date }}
        </span>
        }
        @if (item.created_time) {
        <span class="time-info">
          <fa-icon [icon]="faClock" class="metadata-icon"></fa-icon>
          {{ item.created_time }}
        </span>
        }
      </div>
      }
      @if (!config.showCheckboxes && config.actions.length > 0) {
      <div class="item-actions">
        <div class="dropdown-container">
          <button class="dropdown-toggle" type="button" (click)="toggleDropdown(i, $event)">
            <fa-icon [icon]="faEllipsisV"></fa-icon>
          </button>
          <div class="dropdown-menu" [class.show]="activeDropdown === i">
            @for (action of config.actions; track action) {
            <button class="dropdown-item" [class]="action.cssClass || ''" [disabled]="isActionDisabled(action, item)"
              [style.display]="isActionVisible(action, item) ? 'flex' : 'none'"
              (click)="onActionClick(action, item, $event)">
              <fa-icon [icon]="action.icon" class="item-icon"></fa-icon>
              <span>{{ action.label | translate }}</span>
            </button>
            }
          </div>
        </div>
      </div>
      }
    </div>
    }
    @if (showEmptyState) {
    <div class="empty-message">
      <fa-icon [icon]="faExclamationCircle" class="empty-icon"></fa-icon>
      <span>{{ emptyStateMessage | translate }}</span>
    </div>
    }
  </div>
  }
</div>